export const ListLinkCatalog = [
  { title: 'Шины', image: '/next/gimg/catalog/tyres.png', href: '/catalog/tyres/' },
  { title: 'Диски', image: '/next/gimg/catalog/disks.png', href: '/catalog/discs/' },
  { title: 'Грузовые шины', image: '/next/gimg/catalog/trucktyres.png', href: '/catalog/trucktyres/' },
  { title: 'АКБ', image: '/next/gimg/catalog/accumulators.png', href: '/catalog/accumulators/' },
  { title: 'Автотовары', image: '/next/gimg/catalog/autoparts.png', href: '/catalog/autoparts/' },
  { title: 'Услуги сервиса', image: '/next/gimg/catalog/services.png', href: '/services/' },
];
